export default __webpack_public_path__ + "static/media/flood-biz.ecd0b273.png";